export default "__VITE_ASSET__jFjfN1TU__"